export function cartCouponInteraction() {
	couponFocus()
	initCouponObserver()
}

function initCouponObserver() {
	const cartForm = document.querySelector('.woocommerce-cart-form')
	if (cartForm !== null) {
		const config = { childList: true }
		var cartMutationObserver = new MutationObserver(() => {
			cartCouponInteraction()
		})

		cartMutationObserver.observe(cartForm, config)
	}
}

function couponFocus() {
	const couponCodeField = document.querySelector('input#coupon_code'),
		couponCodeBtn = document.querySelector('button[name="apply_coupon"]')

	if (couponCodeField !== null) {
		couponCodeField.addEventListener('focus', function () {
			couponCodeBtn.classList.remove('btn-outline-primary')
			couponCodeBtn.classList.add('btn-primary')
		})

		couponCodeField.addEventListener('blur', function () {
			couponCodeBtn.classList.add('btn-outline-primary')
			couponCodeBtn.classList.remove('btn-primary')
		})
	}
}

document.addEventListener('DOMContentLoaded', cartCouponInteraction)
